import { TAddAccountFormValues } from 'types/accounts'

export const setAddAccountRoleAssignment = (
  value: { name: string; uuid: string },
  values: TAddAccountFormValues,
  venueUuid: string,
  setFieldValue: (
    field: string,
    value: { userRoleId: string; venueId: string }[],
    shouldValidate?: boolean
  ) => void
) => {
  // Return array of marked role assignments venueId
  const roleAssignmentsVenueUuids = values?.roleAssignments?.map(
    ({ venueId }: { venueId: string }) => venueId
  )

  // Check which role assignment assigned to venue is marked
  if (roleAssignmentsVenueUuids.includes(venueUuid)) {
    // Remove previously marked role assignments
    const removedUnmarkedRoleAssignments = values?.roleAssignments?.filter(
      ({ venueId }) => venueId !== venueUuid
    )

    setFieldValue('roleAssignments', [
      ...removedUnmarkedRoleAssignments,
      { userRoleId: value.uuid, venueId: venueUuid },
    ])
  } else {
    setFieldValue('roleAssignments', [
      ...values.roleAssignments,
      { userRoleId: value.uuid, venueId: venueUuid },
    ])
  }
}
